import * as types from "../actions/actionTypes";

const initialState = {
  tickets: [],
  ticket: null,
  messages: [],
};

const supporttickets = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_SUPPORT_TICKET_RESPONSE:
      return { ...state, tickets: action.payload };
    case types.GET_SUPPORT_TICKET_BY_ID_RESPONSE:
      return { ...state, ticket: action.payload };
    case types.GET_SUPPORT_TICKETS_BY_STATUS_RESPONSE:
      return { ...state, tickets: action.payload };
    case types.GET_OLD_MESSAGES:
      return { ...state, messages: [] };
    case types.GET_OLD_MESSAGES_RESPONSES:
      return { ...state, messages: action.payload };

    case types.CREATE_SUPPORT_TICKET:
      return { ...state, ticket: null };
    case types.UPDATE_SUPPORT_TICKET:
      return { ...state, ticket: null };
    case types.DELETE_SUPPORT_TICKET:
      return { ...state, ticket: null };
    case types.ADD_CHAT_MESSAGE:
      return { ...state, ticket: null };
    default:
      return state;
  }
};

export default supporttickets;
